export default __webpack_public_path__ + "static/media/flatRate.ffb3cd1e.svg";